import React from 'react';
import { Sparkles } from 'lucide-react';

const WelcomeSection = () => {
  return (
    <section className="py-12 md:py-20 px-4 bg-black">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-gradient-to-br from-gray-900 to-black rounded-3xl shadow-xl shadow-blue-500/20 p-8 md:p-12 border border-gray-800 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-600/20 to-blue-800/20 rounded-full -mr-16 -mt-16 blur-2xl"></div>
          <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-blue-600/20 to-blue-800/20 rounded-full -ml-12 -mb-12 blur-2xl"></div>
          
          <div className="relative z-10">
            <div className="flex items-center justify-center mb-6">
              <Sparkles className="h-8 w-8 text-blue-500 mr-3" />
              <h2 className="text-3xl md:text-4xl font-bold text-white">
                Welcome to jalwagameszone
              </h2>
            </div>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed text-center">
              Thanks for visiting! Find quick tips, reliable info, and tools designed to help you smarter.
              Look around and discover what works best for you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
